import React, { useEffect } from 'react';
import LoadingDots from "../../components/ui/LoadingDots";

const PageRedirect = (props) => {
  const { router,
    getCompany,
    createRequest,
    forms,
  } = props;

  useEffect(() => {
    const { router: { params: { orn }} } = props;
    setTimeout(() => getCompany(orn), 500);
  }, []);

  useEffect(() => {
    const { router: { params: { id, slug }}, forms, companies } = props;
    if (window.location.pathname.indexOf('redirect') > -1) {
      router.push(`/residents/${id}`);
    } else if (window.location.pathname.indexOf('create') === -1) {
      router.push('/');
    } else {
      if (forms) {
        const createdForms = forms.sort((a,b)=> b.id - a.id).filter(form => form.request_type_id_slug === slug && form.status === 'Черновик' && !form.is_locked);
        if (createdForms.length > 0) {
          const formId = createdForms[0].id;
          router.push(`/residents/${formId}`);
        } else {
          createRequest(slug);
          router.push(`/residents/create`);
        }
      }
    }
  }, [ forms ]);

  return(
    <>
      <article>
        {/*  Page Content */}
        <div className="hr-line" />
        <LoadingDots show={true} />
      </article>
    </>
  )
};

export default PageRedirect;
